import React, { useState } from "react";
import "../../../stylesheets/components/Reports/HoldingReports/FilterAssetDrop.scss";
import { initFilterTray, initSelectedFilter, } from "./constant";
import { dynamicPNLFilters } from "@domains/aggregates/interfaces/Reports/iPNLReport";
const FilterAssetDropMob = ({ setshowFilterAssetDropdown, setShowFDot, filterData: { simpleFilter, assetFilter, expiryMonth, instrumentType, optionType, strikePrice, underlyingAsset, }, setFilterData, applyFilter, showAsset, replacedFilterName, clearSessionFilters, parentClass, themeClass, }) => {
    const [filterData, setFilterDATA] = useState({
        simpleFilter,
        assetFilter,
        expiryMonth,
        instrumentType,
        optionType,
        strikePrice,
        underlyingAsset,
    });
    const [selectedFilters, setselectedFilters] = useState(initSelectedFilter);
    const [filterTrayOpen, setFilterTrayOpen] = useState(initFilterTray);
    const FiltercounterHelper = (filter, event) => {
        if (!filter)
            return [];
        const { parentNode, checked } = event.target;
        const newFilters = [...filter.filters];
        filter.filters.map((el, index) => {
            if (el.title === parentNode.textContent) {
                newFilters[index] = Object.assign(Object.assign({}, el), { selected: checked });
            }
        });
        return newFilters;
    };
    const filterCounter = (event) => {
        let internalFilterData = filterData;
        internalFilterData.simpleFilter.filters = FiltercounterHelper(filterData.simpleFilter, event);
        if (showAsset)
            internalFilterData.assetFilter.filters = FiltercounterHelper(internalFilterData.assetFilter, event);
        if (expiryMonth) {
            internalFilterData.expiryMonth.filters = FiltercounterHelper(internalFilterData.expiryMonth, event);
            setselectedFilters((prevState) => {
                return Object.assign(Object.assign({}, prevState), { expiryMonth: internalFilterData.expiryMonth.filters.filter((x) => x.selected).length });
            });
        }
        if (instrumentType) {
            internalFilterData.instrumentType.filters = FiltercounterHelper(internalFilterData.instrumentType, event);
            setselectedFilters((prevState) => {
                return Object.assign(Object.assign({}, prevState), { instrumentType: internalFilterData.instrumentType.filters.filter((x) => x.selected).length });
            });
        }
        if (optionType) {
            internalFilterData.optionType.filters = FiltercounterHelper(internalFilterData.optionType, event);
            setselectedFilters((prevState) => {
                return Object.assign(Object.assign({}, prevState), { optionType: internalFilterData.optionType.filters.filter((x) => x.selected).length });
            });
        }
        if (strikePrice) {
            internalFilterData.strikePrice.filters = FiltercounterHelper(internalFilterData.strikePrice, event);
            setselectedFilters((prevState) => {
                return Object.assign(Object.assign({}, prevState), { strikePrice: internalFilterData.strikePrice.filters.filter((x) => x.selected).length });
            });
        }
        if (underlyingAsset) {
            internalFilterData.underlyingAsset.filters = FiltercounterHelper(internalFilterData.underlyingAsset, event);
            setselectedFilters((prevState) => {
                return Object.assign(Object.assign({}, prevState), { underlyingAsset: internalFilterData.underlyingAsset.filters.filter((x) => x.selected).length });
            });
        }
        if (showAsset)
            setselectedFilters((prevState) => {
                return Object.assign(Object.assign({}, prevState), { assetFilter: internalFilterData.assetFilter.filters.filter((x) => x.selected).length });
            });
        else
            setselectedFilters((prevState) => {
                return Object.assign(Object.assign({}, prevState), { assetFilter: 0 });
            });
        setselectedFilters((prevState) => {
            return Object.assign(Object.assign({}, prevState), { simpleFilter: internalFilterData.simpleFilter.filters.filter((x) => x.selected).length });
        });
        setFilterDATA((prevState) => {
            let state = {
                simpleFilter: internalFilterData.simpleFilter,
                assetFilter: internalFilterData.assetFilter,
            };
            if (expiryMonth)
                state.expiryMonth = internalFilterData.expiryMonth;
            if (instrumentType)
                state.instrumentType = internalFilterData.instrumentType;
            if (optionType)
                state.optionType = internalFilterData.optionType;
            if (strikePrice)
                state.strikePrice = internalFilterData.strikePrice;
            if (underlyingAsset)
                state.underlyingAsset = internalFilterData.underlyingAsset;
            return state;
        });
        setFilterData(() => {
            let state = {
                simpleFilter: internalFilterData.simpleFilter,
                assetFilter: internalFilterData.assetFilter,
            };
            if (expiryMonth)
                state.expiryMonth = internalFilterData.expiryMonth;
            if (instrumentType)
                state.instrumentType = internalFilterData.instrumentType;
            if (optionType)
                state.optionType = internalFilterData.optionType;
            if (strikePrice)
                state.strikePrice = internalFilterData.strikePrice;
            if (underlyingAsset)
                state.underlyingAsset = internalFilterData.underlyingAsset;
            return state;
        });
    };
    const applyFilterHandle = () => {
        applyFilter();
        if (!showAsset) {
            setselectedFilters((prevState) => {
                return Object.assign(Object.assign({}, prevState), { assetFilter: 0 });
            });
        }
        setshowFilterAssetDropdown(false);
        let count = Object.values(selectedFilters).reduce((prevFilterCount, currCount) => prevFilterCount + currCount, 0);
        setShowFDot(count);
    };
    const removeFilter = (filter) => {
        return filter === null || filter === void 0 ? void 0 : filter.map((filter) => {
            if (filter.selected) {
                return Object.assign(Object.assign({}, filter), { selected: false });
            }
            return filter;
        });
    };
    const clearAllFilter = () => {
        setselectedFilters(initSelectedFilter);
        setFilterData((prevState) => {
            let clearState = {
                simpleFilter: {
                    name: simpleFilter.name,
                    title: simpleFilter === null || simpleFilter === void 0 ? void 0 : simpleFilter.title,
                    filters: removeFilter(simpleFilter.filters),
                },
                assetFilter: {
                    name: "Asset filter",
                    title: assetFilter === null || assetFilter === void 0 ? void 0 : assetFilter.title,
                    filters: showAsset
                        ? removeFilter(assetFilter === null || assetFilter === void 0 ? void 0 : assetFilter.filters)
                        : [],
                },
            };
            if (expiryMonth)
                clearState.expiryMonth = {
                    name: expiryMonth.name,
                    title: expiryMonth === null || expiryMonth === void 0 ? void 0 : expiryMonth.title,
                    filters: removeFilter(expiryMonth.filters),
                };
            if (instrumentType)
                clearState.instrumentType = {
                    name: instrumentType.name,
                    title: instrumentType === null || instrumentType === void 0 ? void 0 : instrumentType.title,
                    filters: removeFilter(instrumentType.filters),
                };
            if (underlyingAsset)
                clearState.underlyingAsset = {
                    name: underlyingAsset.name,
                    title: underlyingAsset === null || underlyingAsset === void 0 ? void 0 : underlyingAsset.title,
                    filters: removeFilter(underlyingAsset.filters),
                };
            if (strikePrice)
                clearState.strikePrice = {
                    name: strikePrice.name,
                    title: strikePrice === null || strikePrice === void 0 ? void 0 : strikePrice.title,
                    filters: removeFilter(strikePrice.filters),
                };
            if (optionType)
                clearState.optionType = {
                    name: optionType.name,
                    title: optionType === null || optionType === void 0 ? void 0 : optionType.title,
                    filters: removeFilter(optionType.filters),
                };
            return clearState;
        });
        clearSessionFilters();
        applyFilter();
        setshowFilterAssetDropdown(false);
        setShowFDot(0);
    };
    const arrow = (e, filterName) => {
        e.stopPropagation();
        let temp = Object.assign({}, filterTrayOpen);
        Object.entries(replacedFilterName).forEach((x) => {
            if (x[1] == filterName)
                filterName = x[0];
        });
        for (let key in temp)
            if (key === filterName)
                temp[key] =
                    !temp[key];
            else
                temp[key] = false;
        setFilterTrayOpen(temp);
    };
    const showOrHide = (filterName) => {
        Object.entries(replacedFilterName).forEach((x) => {
            if (filterName === x[1])
                filterName = x[0];
        });
        return filterTrayOpen[filterName];
    };
    const DynamicFilters = (filters) => {
        var _a, _b;
        if (filters && filters.name && ((_a = filters.filters) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            let Filtercount = 0;
            Object.entries(replacedFilterName).forEach((x) => {
                if (filters.name === x[1] || filters.title === x[1])
                    Filtercount = selectedFilters[x[0]];
            });
            let showFilter = showOrHide(filters.name);
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { id: "filter", className: "filterasset-drop-head" },
                    React.createElement("p", { onClick: (e) => {
                            arrow(e, filters.name);
                        } },
                        (filters === null || filters === void 0 ? void 0 : filters.title)
                            ? filters === null || filters === void 0 ? void 0 : filters.title
                            : dynamicPNLFilters[filters.name],
                        React.createElement("span", { className: Filtercount > 0 ? "light-blue" : "" }, `(${Filtercount})`)),
                    React.createElement("span", { onClick: (e) => {
                            arrow(e, filters.name);
                        } }, showFilter ? (React.createElement("i", { className: "edel-icon-arrow-up arr-color" })) : (React.createElement("i", { className: "edel-icon-arrow-down arr-color" })))),
                React.createElement("div", { id: "filter", className: `filterasset-drop-body h-auto ${showFilter ? "show" : "hide"}` },
                    React.createElement("ul", null, (_b = filters === null || filters === void 0 ? void 0 : filters.filters) === null || _b === void 0 ? void 0 : _b.map((val, idx) => {
                        return (React.createElement("li", { key: idx },
                            React.createElement("label", { className: "checkbox" },
                                React.createElement("input", { type: "checkbox", checked: val.selected, onChange: filterCounter }),
                                React.createElement("span", { className: "checked edel-icon-tick" }),
                                React.createElement("p", null, val.title))));
                    })))));
        }
    };
    const enableApply = () => {
        for (let key in selectedFilters)
            if (selectedFilters[key] > 0)
                return true;
        return false;
    };
    const InitHandleOpenTray = () => {
        let tray = Object.assign({}, initFilterTray);
        Object.values(filterData).forEach((x) => {
            if ((x === null || x === void 0 ? void 0 : x.filters.length) > 0) {
                if (x.name == "Filter By")
                    tray.simpleFilter = true;
                else
                    tray[x.name] = false;
            }
        });
        setFilterTrayOpen(tray);
    };
    const InitSelectedFilters = () => {
        let filterCounts = Object.assign({}, initSelectedFilter);
        for (let key in filterData) {
            if (filterData[key]) {
                let filterCount = filterData[key].filters.filter((x) => x.selected).length;
                if (filterCount > 0)
                    filterCounts[key] = filterCount;
            }
        }
        setselectedFilters(filterCounts);
    };
    React.useEffect(() => {
        InitHandleOpenTray();
        InitSelectedFilters();
    }, []);
    return (React.createElement("div", { className: `${themeClass !== null && themeClass !== void 0 ? themeClass : "filterasset-drop "} ${parentClass ? parentClass : null}` },
        Object.entries(filterData).map((val) => {
            React.createElement("div", { className: "filter-asset-seperator" });
            if (val[0] == "assetFilter")
                return showAsset && DynamicFilters(val[1]);
            return DynamicFilters(val[1]);
        }),
        React.createElement("div", { className: "filterasset-drop-footer" },
            React.createElement("input", { className: " clear_all filter-button", type: "button", value: "Clear All", onClick: clearAllFilter }),
            React.createElement("input", { className: enableApply()
                    ? "filter-button aply-btn"
                    : " filter-button aply-btn filter-button-disable", type: "button", value: "Apply", onClick: applyFilterHandle }))));
};
export default React.memo(FilterAssetDropMob);
